import { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const PatientDetailsRecordsFreetype = ({
  patientDBdata,
  patientID,
  setPatientDBdata,
  noteActualId,
}) => {
  const [tempHtml, setTempHtml] = useState('')
  const [originalHtml, setOriginalHtml] = useState('')

  /* ----------------------------------
     GENERATE HTML
  ---------------------------------- */
  const generatePatientDetailsHtml = () => `
    <div>
      <p style="font-weight:700;font-size:17px;margin:0;">
        Bay Area Neurology LLC
      </p>
      <p style="font-size:17px;margin:0;">Correspondence address</p>
      <p style="font-size:17px;margin:0;">
        3225 S MACDILL AVE STE 129-300, TAMPA, FL, 33629-8171
      </p>

      <hr />

      <p>
        <strong>Patient Name:</strong>
        ${patientDBdata?.patientData?.FirstName || ''} 
        ${patientDBdata?.patientData?.MiddleName || ''} 
        ${patientDBdata?.patientData?.LastName || ''}
      </p>

      <p><strong>Patient Type:</strong>
        ${patientDBdata?.appointmentData?.term || '-'}
      </p>

      <p><strong>DOB:</strong>
        ${patientDBdata?.patientData?.DOB || '-'}
      </p>

      <p><strong>Visit On:</strong>
        ${
          patientDBdata?.appointmentData?.StartTime
            ? patientDBdata.appointmentData.StartTime.split(' ')[0]
            : '-'
        }
      </p>

      <hr />

      <p><strong>Location:</strong>
        ${patientDBdata?.details?.FacilityName || '-'}
      </p>

      <p><strong>Room No:</strong>
        ${patientDBdata?.patientData?.Room || '-'}
      </p>
    </div>
  `
  useEffect(() => {
    const savedHtml =
      patientDBdata?.currentNote?.data?.freeTypesEverything?.patientDetails

    const generatedHtml = generatePatientDetailsHtml()

    setOriginalHtml(generatedHtml)
    setTempHtml(savedHtml || generatedHtml)

    // Save initial HTML if not present
    if (!savedHtml) {
      setPatientDBdata((prev) => ({
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev?.currentNote?.data,
            freeTypesEverything: {
              ...prev?.currentNote.data?.freeTypesEverything,
              patientDetails: generatedHtml,
            },
          },
        },
      }))
    }
  }, [patientDBdata])

  const handleBlur = () => {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            patientDetails: tempHtml,
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteActualId) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
              patientDetails: tempHtml,
            },
          }),
        }
      }),
    }))
  }

  return (
    <div className="d-flex">
      <div className="w-100">
        <Editor
          value={tempHtml}
          onChange={(e) => setTempHtml(e.target.value)}
          onBlur={handleBlur}
          containerProps={{
            style: {
              width: '100%',
              background: '#2D2D2D',
              color: 'white',
              border: 0,
            },
          }}
        >
          <Toolbar hidden />
        </Editor>
      </div>
    </div>
  )
}

export default PatientDetailsRecordsFreetype
